import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

const size = '325px';
const statusCardStyle = {
    flexGrow: '2',
    minWidth: size,
    maxWidth: size,
};

const OverviewSyncStatusCard = ({
    classes,
    icon,
    heading = '',
    text = '',
    dropdownItems = [],
    hasPermission = false,
    showStaleBorder = false
}) => {

    // only show dropdown if there are items and the user has permission
    const dropdownOptions = () => {
        if (hasPermission && dropdownItems.length > 0) {
            return (
                <UncontrolledDropdown>
                <DropdownToggle
                    nav
                    className="text-light"
                    style={{
                        position: 'absolute',
                        right: '0px',
                    }}>
                    <FontAwesomeIcon icon={faEllipsisV} size="lg" />
                </DropdownToggle>
                <DropdownMenu right>
                    {dropdownItems.map(
                        (
                            { itemAction: action, itemText: text },
                            index
                        ) => (
                            <DropdownItem
                                className=""
                                key={index}
                                onClick={action}>
                                {text || ''}
                            </DropdownItem>
                        )
                    )}
                </DropdownMenu>
                </UncontrolledDropdown>
            );
        }
    }

    return (
        <div className="my-1" style={statusCardStyle}>
            <div
                className={`sc-rounded sc-shadow d-flex justify-content-between ${classes}`}>
                <div className="align-self-center">
                    <div className="px-2">{icon}</div>
                </div>
                <div className={`w-100 text-12 p-2 bg-dark-opacity-3 sc-rounded text-center ${showStaleBorder ? 'border border-thick border-danger' : ''}`}>
                    <h6>{heading}</h6>
                    {text}
                </div>
                <div>
                    {dropdownOptions()}
                </div>
            </div>
        </div>
    );
};

export default OverviewSyncStatusCard;
